/**
 * @author        david.loehr@zumper.com (David Loehr)
 * @copyright     Copyright (c) 2024, Zumper
 */
import { falseReducer, nullReducer, payloadKeyReducer, trueReducer } from '@zcode/reducers'
import type { CancellationPoliciesWithMeta } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { handleAction, handleActions } from 'redux-actions'
import {
  DONE_FETCHING_CANCELLATION,
  ERROR_FETCHING_CANCELLATION,
  RECEIVE_CANCELLATION,
  START_FETCHING_CANCELLATION,
} from '../constants'
import type { ActionTypes } from './types'

type Meta = CancellationPoliciesWithMeta['meta']

export const meta = combineReducers<Meta, ActionTypes>({
  error: handleActions<Meta['error'], ActionTypes>(
    {
      [ERROR_FETCHING_CANCELLATION]: trueReducer,
      [RECEIVE_CANCELLATION]: falseReducer,
    },
    false
  ),
  fetchingKey: handleActions<Meta['fetchingKey'], ActionTypes>(
    {
      [DONE_FETCHING_CANCELLATION]: nullReducer,
      [START_FETCHING_CANCELLATION]: payloadKeyReducer('key'),
    },
    null
  ),
  currentKey: handleAction<Meta['currentKey'], ActionTypes, typeof RECEIVE_CANCELLATION>(
    RECEIVE_CANCELLATION,
    payloadKeyReducer('key'),
    null
  ),
})
